<kendo-dialog
  title="{{ '_Report_Filters_Share_Template_Text_' | translate }}"
  *ngIf="shareDialogOpened"
  [minWidth]="300"
  [width]="500"
  (close)="close()"
  class="share-template cc-dialog-sm"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <div class="mb-3">
    {{ "_Report_Filters_Share_Popup_Description_Text_" | translate }}
  </div>

  <div class="mb-2">
    <label>
      {{ "_General_Users_Text_" | translate }}
    </label>
    <ng-multiselect-dropdown
      [placeholder]="'_General_Select_Text_' | translate"
      [settings]="usersDropdownSettings"
      [data]="filteredShareableUsersList"
      [(ngModel)]="sharedUsers"
    ></ng-multiselect-dropdown>
  </div>

  <div class="mb-2">
    <label>
      {{ "_Report_Filters_Share_Popup_Permission_Group_Text_" | translate }}
    </label>
    <ng-multiselect-dropdown
      [placeholder]="'_General_Select_Text_' | translate"
      [settings]="permissionGroupsDropdownSettings"
      [data]="shareablePermissionGroupsList"
      [(ngModel)]="sharedPermissionGroups"
    ></ng-multiselect-dropdown>
  </div>

  <kendo-dialog-actions class="cc-btn-panel">
    <button
      id="shareFilterTmpCancelBtn"
      class="btn btn-secondary"
      (click)="clickCancel()"
      [disabled]="false"
    >
      {{ "_General_Button_Cancel_Text_" | translate }}
    </button>
    <button
      id="shareFilterTmpSaveBtn"
      class="btn btn-primary"
      (click)="clickSave()"
      [disabled]="checkSaveDisabled()"
    >
      {{ "_General_Button_Save_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
